<template>
  <div class="sidebar" :class="sidebarClasss">
    <div class="user" style="z-index: 3">
      <div class="photo photo-full text-center mb-3">
        <img :src="logo" id="adminNavLogoImg" />
      </div>
    </div>
    <div class="sidebar-wrapper">
      <!-- {{ url_base }} ---
      {{ sidebar_items }} -->
      <ul class="nav">
        <li v-for="(item, index) in sidebar_items" :key="index" class="nav-item">
          <router-link :to="'/' + url_base + '/' + item.url" class="nav-link d-flex" v-if="!item.disabled">
            <img class="my-nav-icon my-nav-icon-grey" :src="item.default_icon" alt="" />
            <img class="my-nav-icon my-nav-icon-top" :src="item.active_icon" alt="" />
            <!-- <p>{{ item.title }}</p> -->
            <p>{{ $t(item.title) }} </p>
          </router-link>
          <a class="nav-link d-flex" v-else>
            <img class="my-nav-icon my-nav-icon-grey" :src="item.default_icon" alt="" />
            <img class="my-nav-icon my-nav-icon-top" :src="item.active_icon" alt="" />
            <!-- <p>{{ item.title }}</p> -->
            <p class="position-relative" style="width: 60%">
              {{ $t(item.title) }}
              <span class="position-absolute top-50 start-100 translate-middle badge rounded-pill bg-danger ">
                Soon
              </span>
            </p>
          </a>
        </li>

        <li class="nav-item">
          <a class="nav-link d-flex" href="" @click="logout">
            <img class="my-nav-icon my-nav-icon-grey nav-logout" :src="logout_default_icon" alt="" />
            <img class="my-nav-icon my-nav-icon-top nav-logout" :src="logout_active_icon" alt="" />
            <p>{{ $t('logout') }}</p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
  
<script>
export default {
  name: "Sidebar",
  components: {},
  props: [
    "sidebarClasss",
    "url_base",
    "logo",
    "sidebar_items",
    "logout_default_icon",
    "logout_active_icon",
  ],
  data() {
    return {};
  },
  methods: {
    logout() {
      // console.log("logoutt ");
      //  console.log(this.$children)
      // this.$confirm({
      //   title: 'Are you sure?',
      //   message: 'Are you sure you want to logout?',
      //   button: {
      //     yes: 'Yes',
      //     no: 'Cancel'
      //   },
      //   callback: confirm => {
      //     if (confirm) {
      localStorage.removeItem("user");
      // localStorage.removeItem("user_type");
      // localStorage.removeItem("admin_type");
      localStorage.removeItem("customer");
      localStorage.removeItem("last_update")
      //  App.isLogin = false;

      // console.log(localStorage);
      //     }
      //   }
      // })
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/HomeLayout/Sidebar.vue